//documentos
export const permissionsKeys = {
  page: 'document-schema.find',
  pageBlockFind: 'document-schema.find',
  pageBlockCreate: 'document-schema.create',
  pageBlockUpdate: 'document-schema.update',
  pageBlockRemove: 'document-schema.remove',
  pageBlockShareWithDependencies: 'document-schema.update',
  pageBlockShareWithUsers: 'document-schema.update',
};
